import { createFileRoute, redirect } from "@tanstack/react-router";
import ChildDataViewPage from "@/pages/ChildDataViewPage";
import { isAdminBuild } from "@/utils/isAdminBuild";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/admin/child-data-view"
)({
  beforeLoad: ({ context, params }) => {
    if (
      !isAdminBuild() ||
      params.leaid !== "0-" ||
      !context.hasRole("ADMIN")
    ) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
  component: ChildDataViewPage,
});
